import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { State } from "appworks/state-machine/states/state";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { AbstractMatrixComponent, DimType } from "slotworks/components/matrix/abstract-matrix-component";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { ScatterResult } from "slotworks/model/gameplay/records/results/scatter-result";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";

export interface FreespinCelebrationConfig {
    minHighlightTime: number;
}
export class FreespinCelebrationState extends State {

    protected config: FreespinCelebrationConfig = {
        minHighlightTime: 0
    };

    constructor(config?: Partial<FreespinCelebrationConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        const allSymbols = Components.get(AbstractMatrixComponent).getBaseGridSymbols();

        const freespins = record.getResultsOfType(FreespinWinResult);

        if (freespins.length === 0) {
            this.complete();
        } else {
            const linked = freespins[0].linkedResult;

            let resultToAnimate: SymbolWinResult;
            // If any symbol win result is linked to freespins win, use that, else default to animating first scatter win
            if (linked instanceof SymbolWinResult) {
                resultToAnimate = linked;
            } else {
                resultToAnimate = record.getFirstResultOfType(ScatterResult);
            }

            if (!resultToAnimate) {
                this.complete();
                return;
            }

            const symbolID = resultToAnimate.symbolType;

            const winningSymbols = Components.get(AbstractMatrixComponent).getSymbolsFromPositions(resultToAnimate.positions);

            Services.get(SoundService).event(SoundEvent.symbol_ID_celebrate, symbolID);
            Services.get(SoundService).event(SoundEvent.symbol_any_celebrate);

            const hiddenSymbols = Components.get(AbstractMatrixComponent).getHiddenSymbols();
            Components.get(AbstractMatrixComponent).dimSymbols(allSymbols.concat(hiddenSymbols), DimType.Win, resultToAnimate).execute();

            new Parallel([
                () => Components.get(AbstractMatrixComponent).highlightSymbols(winningSymbols, resultToAnimate),
                () => Contract.getTimeoutContract(this.config.minHighlightTime)
            ]).then(() => {
                Components.get(AbstractMatrixComponent).resetSymbols();
                this.complete();
            });
        }
    }
}
